import React, { Component } from "react"
import styled from "styled-components"

const RelativeWrapper = styled.div.attrs({
  className: "gl-levels__requirements__loader-circle-wrapper text-center"
})`
  max-width: ${props => (props.size - props.stroke)}px;
  min-width: ${props => (props.size - props.stroke)}px;
  min-height: ${props => (props.size - props.stroke)}px;
  max-height: ${props => (props.size - props.stroke)}px;
  border-radius: 50%;
`

class CircularLoader extends Component {
  static defaultProps = {
    radius: 55,
    stroke: 6,
    progress: 0,
    expected_progress: 0,
    id: ""
  }
  handler = undefined

  constructor(props) {
    super(props)
    const { radius, stroke } = props
    this.normalizedRadius = radius - stroke * 2
    this.circumference = this.normalizedRadius * 2 * Math.PI
    this.state = {
      progressDashOffset: this.circumference,
      expectedProgressDashOffset: this.circumference
    }
  }

  calcStrokeDashoffset(p) {
    return this.circumference - (p / 100) * this.circumference
  }

  componentDidMount() {
    const { progress } = this.props
    const progressStrokeDashoffset = this.calcStrokeDashoffset(progress)

    this.handler = setTimeout(() => {
      this.setState({
        progressDashOffset: progressStrokeDashoffset
      })
    }, 300)
  }

  componentWillUnmount() {
    clearTimeout(this.handler)
  }

  render() {
    const {
      radius,
      stroke,
      children,
      color,
      id,
      containerclassName,
      svgclassName,
      svgContainerClassName
    } = this.props

    return (
      <div className={`relative ${containerclassName}`}>
        <svg height={radius * 2} width={radius * 2} className={svgContainerClassName}>
          <circle
            className={svgclassName}
            fill="transparent"
            strokeWidth={stroke + 3}
            r={this.normalizedRadius}
            cx={radius}
            cy={radius}
          />

          <circle
            id={`levelprog-${id}`}
            stroke={color}
            className="gl-progress-ring__loader"
            strokeLinecap="round"
            fill="transparent"
            strokeWidth={stroke + 1}
            strokeDasharray={this.circumference + " " + this.circumference}
            style={{ strokeDashoffset: this.state.progressDashOffset }}
            // style={ { strokeDashoffset } }
            r={this.normalizedRadius}
            cx={radius}
            cy={radius}
          />
          <use
            xlinkHref={`#levelprog-${id}`}
          />
        </svg>

        <RelativeWrapper size={this.normalizedRadius * 2} stroke={stroke}>
          {children}
        </RelativeWrapper>
      </div>
    )
  }
}

export default CircularLoader
